function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18 16.75a.75.75 0 01-.6-1.2 5.94 5.94 0 000-7.1.75.75 0 011.2-.9c1.96 2.62 1.96 6.28 0 8.9-.15.2-.37.3-.6.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.83 19.25a.75.75 0 01-.6-1.2c2.67-3.56 2.67-8.54 0-12.1a.75.75 0 011.2-.9c3.07 4.09 3.07 9.81 0 13.9-.14.2-.37.3-.6.3z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.75 7.41v9.18c0 1.72-.62 3.01-1.73 3.63a3 3 0 01-1.47.37c-.8 0-1.66-.27-2.54-.82l-2.92-1.83c-.2-.12-.43-.19-.66-.19H5.5V6.25h.93c.23 0 .46-.07.66-.19l2.92-1.83c1.46-.91 2.89-1.07 4.01-.45 1.11.62 1.73 1.91 1.73 3.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 6.25v11.5H5c-2.42 0-3.75-1.33-3.75-3.75v-4c0-2.42 1.33-3.75 3.75-3.75h.5z"
})));